import { KlevuFilterType } from "../models/index.js";
/**
 * build a string|undefined from active filters in format that is required by Klevu API
 *
 * @param result the api result object
 */
export function extractActiveFilters(result) {
    var _a;
    let selectedFiltersStr = "";
    let isAnyFilterSelected = false;
    if (!result.filters || result.filters.length === 0) {
        return undefined;
    }
    (_a = result.filters) === null || _a === void 0 ? void 0 : _a.forEach((filter) => {
        if (filter.type === KlevuFilterType.Slider) {
            if (!filter.start || !filter.end) {
                return;
            }
            if (filter.start != filter.min || filter.end != filter.max) {
                if (isAnyFilterSelected) {
                    selectedFiltersStr += ";;";
                }
                isAnyFilterSelected = true;
                selectedFiltersStr +=
                    filter.key + ":" + filter.start + " - " + filter.end;
            }
        }
        else {
            filter.options.forEach((option) => {
                if (!option.selected) {
                    return;
                }
                if (isAnyFilterSelected) {
                    selectedFiltersStr += ";;";
                }
                isAnyFilterSelected = true;
                selectedFiltersStr += filter.key + ":" + option.name;
            });
        }
    });
    return isAnyFilterSelected ? selectedFiltersStr : undefined;
}
